// components/Section.js
import React, { useState, useContext } from 'react';
import { SectionOpenContext } from './OrderBento';

function Section({ title, children, defaultOpen = false }) {
  // Sections inside a bento SectionModal start expanded; everywhere else
  // the context defaults to false and behavior is unchanged.
  const insideModal = useContext(SectionOpenContext);
  const [open, setOpen] = useState(defaultOpen || insideModal);
 
  return (
    <div className="border border-gray-300 mb-4 rounded">
      <div 
        className="bg-gray-100 px-4 py-2 cursor-pointer" 
        onClick={() => setOpen(!open)}
      >
        <h3 className="font-semibold text-center w-full">
          {open ? '▾' : '▸'} {title}
        </h3>
      </div>
      {open && <div className="p-4 bg-white">{children}</div>}
    </div>
  );
}

export default Section;